import Vue from 'vue'
import Vuex from 'vuex'

import auth from "./modules/auth"
import member from "./modules/member"

Vue.use(Vuex)

export const store = new Vuex.Store({

  modules: {
    auth,
    member
  },

  state: {   
  },

  mutations: {
   
  },
  actions: {
   
  },
  getters: {    

  }
});


